import { Stack, Typography, Chip } from "@mui/material";

import NavigateNext from "@mui/icons-material/NavigateNext";
import IconButton from "@mui/material/IconButton";

import { ReactComponent as IconWarning } from "../../../images/warning-2.svg";

import "./styles.css";

export default function Card({ title, chipLabel = "", text, onClick }) {
  return (
    <Stack id="PerfilComleto_modulo_card" className="container">
      <Stack>
        <Stack className="header">
          <Typography className="title">{title}</Typography>
          <IconButton size="small" onClick={onClick}>
            <NavigateNext style={{ color: "#1E729F" }} fontSize="large" />
          </IconButton>
        </Stack>
        <Typography className="text">{text}</Typography>
      </Stack>

      {chipLabel && (
        <Chip
          className="chip"
          label={chipLabel}
          icon={
            <IconWarning
              className="colorIconWarning"
              style={{ width: "24px" }}
            />
          }
        />
      )}
    </Stack>
  );
}
